<template>
  <div class="rich-text-editor">
    <label v-if="label" class="text-body-2 text-medium-emphasis mb-1 d-block">{{ label }}</label>
    <QuillEditor
      :content="modelValue"
      content-type="html"
      theme="snow"
      :toolbar="toolbar"
      :placeholder="placeholder"
      @update:content="onUpdate"
    />
  </div>
</template>

<script setup>
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

defineProps({
  modelValue: { type: String, default: "" },
  label: { type: String, default: "" },
  placeholder: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue"]);

const toolbar = [
  ["bold", "italic", "underline"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ header: [1, 2, 3, false] }],
  ["link"],
  ["clean"],
];

function onUpdate(content) {
  const value = content === "<p><br></p>" ? "" : (content || "");
  emit("update:modelValue", value);
}
</script>

<style scoped>
.rich-text-editor :deep(.ql-container) {
  min-height: 120px;
  font-size: 1rem;
}

.rich-text-editor :deep(.ql-editor) {
  min-height: 120px;
}
</style>
